import { render, staticRenderFns } from "./RulesTab.vue?vue&type=template&id=8ad68d08"
import script from "./RulesTab.vue?vue&type=script&lang=js"
export * from "./RulesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports